import { UI_PRIMITIVE__checkbox } from '@/components/ui/UI_PRIMITIVE__checkbox';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_workspace_update } from '@/state/workspace/entity/remote_workspace_update';
import { useTranslation } from 'react-i18next';

export function WCheckboxEnableInviteByLink() {
  const dispatch = use_dispatch();

  const { workspace_current } = use_slice_workspace(['workspace_current']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  async function onChange() {
    let workspace_new = workspace_current.clone({ invite_by_link_enabled: !workspace_current.invite_by_link_enabled });

    await dispatch(remote_workspace_update(workspace_new));
  }

  return (
    <div className="flex items-center mt-2">
      <UI_PRIMITIVE__checkbox id="WCheckboxEnableInviteByLink" checked={workspace_current.invite_by_link_enabled} onCheckedChange={onChange} />
      <label htmlFor="WCheckboxEnableInviteByLink" className={`ml-2 text-sm cursor-pointer ${workspace_current.invite_by_link_enabled ? '' : 'opacity-50'}`}>
        {t(i18n_page_settings_workspace.tabs.users.shared.invite_by_link_component.checkbox.enable)}
      </label>
    </div>
  );
}
